import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PreptimeService } from '../PreptimeService';

export const initPrepTimeServiceResolver: ResolveFn<boolean> = (route) => {
  const prepService = inject(PreptimeService);
  return prepService.init();
};
